import {
  IconCheck,
  IconClock,
  IconStopwatch,
  IconX,
} from "@tabler/icons-react";
import type { ReactNode } from "react";

class COrderStatus {
  public static PENDING = "PENDING";
  public static PAID = "PAID";
  public static EXPIRED = "EXPIRED";
  public static CANCELLED = "CANCELLED";

  public color: string;
  public nameKey: string;
  public name: string;
  public icon: ReactNode;
  public description: string;
  public descriptionKey: string;
  public status: string;

  private variants = {
    [COrderStatus.CANCELLED]: {
      color: "#ff4d4f",
      name: "Annulée",
      nameKey: "status.cancelled.name",
      icon: <IconX size={15} />,
      description:
        "Votre commande est annulée. Vous ne pouvez plus accéder à vos produits.",
      descriptionKey: "status.cancelled.description",
    },
    [COrderStatus.EXPIRED]: {
      color: "#ff4d4f",
      name: "Expirée",
      nameKey: "status.expired.name",
      icon: <IconStopwatch size={15} />,
      description:
        "Votre commande est expirée. Vous ne pouvez plus accéder à vos produits.",
      descriptionKey: "status.expired.description",
    },
    [COrderStatus.PAID]: {
      color: "#1890ff",
      name: "Payée",
      nameKey: "status.paid.name",
      icon: <IconCheck size={15} />,
      description: "",
      descriptionKey: "status.paid.description",
    },
    [COrderStatus.PENDING]: {
      color: "#faad14",
      name: "En attente",
      nameKey: "status.pending.name",
      icon: <IconClock size={15} />,
      description:
        "Votre commande est en attente de paiement. Une fois le paiement effectué, vous recevrez vos identifiants.",
      descriptionKey: "status.pending.description",
    },
  };

  constructor(status: string) {
    const { color, description, icon, name, nameKey, descriptionKey } =
      this.variants[status];

    this.color = color;
    this.description = description;
    this.descriptionKey = descriptionKey;
    this.icon = icon;
    this.name = name;
    this.nameKey = nameKey;
    this.status = status;
  }

  public isPaid = () => this.status === COrderStatus.PAID;

  public isPending = () => this.status === COrderStatus.PENDING;

  public isExpired = () => this.status === COrderStatus.EXPIRED;
}

export default COrderStatus;
